/* TASKS */
export const GET_TASKS = "GET_TASKS";
export const GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS";
export const GET_TASKS_FAIL = "GET_TASKS_FAIL";
export const GET_ADDED_TASKS = "GET_ADDED_TASKS";
export const UPDATE_TASK = "UPDATE_TASK";
export const CHECK_SINGLE = "CHECK_SINGLE";
